'use client';

import { Plus, Upload } from 'lucide-react';
import { Button } from '@/components/ui/forms/button';
import { cn } from '@/lib/utils';

interface ResumeUploadCreateActionsProps {
  onUpload: () => void;
  onCreate: () => void;
  className?: string;
  buttonSize?: 'sm' | 'default' | 'lg' | 'icon';
  uploadDisabled?: boolean;
}

export function ResumeUploadCreateActions({
  onUpload,
  onCreate,
  className,
  buttonSize = 'default',
  uploadDisabled,
}: ResumeUploadCreateActionsProps) {
  return (
    <div className={cn('flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center', className)}>
      <Button
        variant="outline"
        size={buttonSize}
        onClick={onUpload}
        className={cn(
          'w-full justify-center sm:w-auto',
          buttonSize === 'sm' ? 'h-9 px-3' : 'h-10 px-5'
        )}
        style={{ boxShadow: 'var(--shadow-warm-sm)' }}
        disabled={uploadDisabled}
      >
        <Upload className="mr-2 h-4 w-4" />
        Upload Resume
      </Button>
      <Button
        size={buttonSize}
        onClick={onCreate}
        className={cn(
          'w-full justify-center sm:w-auto',
          buttonSize === 'sm' ? 'h-9 px-3' : 'h-10 px-5'
        )}
        style={{ boxShadow: 'var(--shadow-warm-sm)' }}
      >
        <Plus className="mr-2 h-4 w-4" />
        Create Resume
      </Button>
    </div>
  );
}
